import React, { useState } from "react";
import { ExternalLink } from "lucide-react";
import { getPlayableAssetUrl } from "../../utils/assetUrl";
import {
  YOUTUBE_IFRAME_ALLOW,
  buildYouTubeEmbedSrc,
  getYouTubeVideoId,
} from "../../utils/youtube";

/** The delivered ad: a YouTube embed or a native player, with a link out when it cannot play here. */
const AdVideo = ({ tag }) => {
  const [isBroken, setIsBroken] = useState(false);
  const url = getPlayableAssetUrl(tag);
  const youTubeId = getYouTubeVideoId(url);

  if (!url) {
    return <p className="text-sm text-gray-500">No video on this delivery.</p>;
  }

  return (
    <div className="space-y-2">
      <div className="flex justify-center overflow-hidden rounded-lg bg-black">
        {youTubeId ? (
          <iframe
            title="Ad video"
            src={buildYouTubeEmbedSrc(youTubeId)}
            allow={YOUTUBE_IFRAME_ALLOW}
            allowFullScreen
            className="aspect-[9/16] max-h-[440px] w-full"
          />
        ) : isBroken ? (
          <p className="px-4 py-10 text-center text-sm text-gray-300">
            This video can&apos;t play here.
          </p>
        ) : (
          <video
            src={url}
            controls
            preload="metadata"
            onError={() => setIsBroken(true)}
            className="max-h-[440px] w-full object-contain"
          />
        )}
      </div>
      <a
        href={url}
        target="_blank"
        rel="noreferrer"
        className="inline-flex items-center gap-1 text-xs text-gray-500 hover:text-gray-800"
      >
        <ExternalLink className="h-3.5 w-3.5" />
        Open the video
      </a>
    </div>
  );
};

export default AdVideo;
